import initialState from './initialState';
import {
  TRANSFER_OWNER_DONE,
  TRANSFER_OWNER_ERROR,
  TRANSFER_OWNER_LOADING,
  TRANSFER_OWNER_SUCCESS
} from '../actions/actionTypes';

export default (state = initialState, action) => {
  switch (action.type) {
    case TRANSFER_OWNER_LOADING:
      return {
        ...state,
        transferLoading: true
      };
    case TRANSFER_OWNER_SUCCESS:
      return {
        ...state,
        transferError: null
      };
    case TRANSFER_OWNER_ERROR:
      return {
        ...state,
        transferError: action.error
      };
    case TRANSFER_OWNER_DONE:
      return {
        ...state,
        transferLoading: false
      };
    default:
      return state;
  }
};
